import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
import enCommon from './locales/en/common';
import enHome from './locales/en/home';
import enAuth from './locales/en/auth';
import enSettings from './locales/en/settings';
import enFreelancers from './locales/en/freelancers';
import enAlliances from './locales/en/alliances';
import enNotifications from './locales/en/notifications';
import enJobs from './locales/en/jobs';
import enProspects from './locales/en/prospects';
import enQuotes from './locales/en/quotes';
import enProjects from './locales/en/projects';
import enDashboard from './locales/en/dashboard';
import enReviews from './locales/en/reviews';
import enReports from './locales/en/reports';
import enCredits from './locales/en/credits';
import enAdmin from './locales/en/admin';
import enHub from './locales/en/hub';
import enProfile from './locales/en/profile';
import enContact from './locales/en/contact';
// French translations
import frCommon from './locales/fr/common';
import frHome from './locales/fr/home';
import frAuth from './locales/fr/auth';
import frSettings from './locales/fr/settings';
import frFreelancers from './locales/fr/freelancers';
import frAlliances from './locales/fr/alliances';
import frNotifications from './locales/fr/notifications';
import frJobs from './locales/fr/jobs';
import frProspects from './locales/fr/prospects';
import frQuotes from './locales/fr/quotes';
import frProjects from './locales/fr/projects';
import frDashboard from './locales/fr/dashboard';
import frReviews from './locales/fr/reviews';
import frReports from './locales/fr/reports';
import frCredits from './locales/fr/credits';
import frAdmin from './locales/fr/admin';
import frHub from './locales/fr/hub';
import frProfile from './locales/fr/profile';
import frContact from './locales/fr/contact';
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        alliances: enAlliances,
        common: enCommon,
        home: enHome,
        auth: enAuth,
        settings: enSettings,
        freelancers: enFreelancers,
        notifications: enNotifications,
        jobs: enJobs,
        prospects: enProspects,
        quotes: enQuotes,
        projects: enProjects,
        dashboard: enDashboard,
        reviews: enReviews,
        reports: enReports,
        credits: enCredits,
        admin: enAdmin,
        hub: enHub,
        profile: enProfile,
        contact: enContact,
      },
      fr: {
        alliances: frAlliances,
        common: frCommon,
        home: frHome,
        auth: frAuth,
        settings: frSettings,
        freelancers: frFreelancers,
        notifications: frNotifications,
        jobs: frJobs,
        prospects: frProspects,
        quotes: frQuotes,
        projects: frProjects,
        dashboard: frDashboard,
        reviews: frReviews,
        reports: frReports,
        credits: frCredits,
        admin: frAdmin,
        hub: frHub,
        profile: frProfile,
        contact: frContact,
      },
    },
    defaultNS: 'common',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
